import { IIdName } from './id-name';
import { IDeletedParam, IQueryStrictParams, IRequestParams } from './page';
import { StorageType } from "./shard-repository";

export interface IShardClusterListItem extends IIdName<string> {
}

export interface IShardClusterDetailsItem extends IShardClusterListItem {
    contentRedundancyLevel: number;
    keyRedundancyLevel: number;
    metaRedundancyLevel: number;
    contentSecurityLevel: number;
    keySecurityLevel: number;
    metaSecurityLevel: number;

    contentStorageNodes?: IIdName<string>[];
    keyStorageNodes?: IIdName<string>[];
    metaStorageNodes?: IIdName<string>[];
}

export interface IShardClusterRequestParams extends
    IRequestParams<ShardClusterSortField>,
    IQueryStrictParams,
    IDeletedParam {
    fields?: (keyof IShardClusterListItem)[];
    pool?: string;
    unused?: boolean;
    provider?: StorageType;
}

export enum ShardClusterSortField {
    Name = "name",
    Id = "id"
}

export interface IShardClusterSecurityLevel {
    ContentSecurityLevel: number;
    KeySecurityLevel: number;
    MetaSecurityLevel: number;
}

export interface IShardClusterCreateRequest extends IShardClusterSecurityLevel {
    name: string;
    keyStorages: string[];
    contentStorages: string[];
    metaStorages: string[];
}

export interface IShardClusterUpdateRequest extends IIdName<string> {
}


export interface IShardClusterFilterParams {
    q?: string,
}

export interface IDefaultShardClusterEndpoint {
  id: string;
  region: string;
}

export interface IDefaultShardClusterSection {
  endpoints: IDefaultShardClusterEndpoint[];
  securityLevel: number;
}

export interface IDefaultShardCluster {
  content: IDefaultShardClusterSection;
  key: IDefaultShardClusterSection;
  meta: IDefaultShardClusterSection;
}
